module.exports = __webpack_public_path__ + "static/Portrait-of-Oliver-min-80e24f1e7d15d36193b2a69c547d9319.webp";